import '../styles/style.scss'
import './utils/polyfills'
import './utils/detectTouch'
import './utils/responsiveHelper'
import ResizeHandler from './utils/resize-active'
import {initMobileNav, initAccessibilityNav, initCollapsible, initHeaderHeight, initSearch} from './components/initMobileNav'
import initPagination from './components/initPagination'
import initShare from './components/share'
import initProjects from './components/initProjects'
import initStaffBoxCollapsible from './components/initContacts'

import 'intersection-observer' // Polyfill IntersectionObserver API for IE and old Safari
import LazyLoad from 'vanilla-lazyload' // Lazy load images plugin

const resizeHandler = new ResizeHandler()

window.addEventListener('DOMContentLoaded', () => {
  const lazyLoadInsance = new LazyLoad()
  lazyLoadInsance.update()
  resizeHandler.init()
  initMobileNav()
  initAccessibilityNav()
  initCollapsible()
  initHeaderHeight()
  initSearch()
  initPagination()
  initShare()
  initProjects()
  initStaffBoxCollapsible()
})

window.onload = () => {
  document.querySelector('html').classList.add('is-loaded');
}
